React = require 'react'
t = require('views/internal/recup-with-helpers')('board_list')

module.exports = class extends React.Component
  displayName: 'BoardListSectionHeaderComponent'
  render: t.renderable ->
    { logoHash, title, iconClass, smallIconClass, smallIconTitleKey, linkElements } = @props

    if logoHash
      orgLogoUrl1x = "#{window.logoDomain}/#{logoHash}/30.png"
      orgLogoUrl2x = "#{window.logoDomain}/#{logoHash}/170.png"

    t.div '.boards-page-board-section-header', ->

      t.div '.boards-page-board-section-header-icon', ->
        if logoHash
          t.img
            class: "boards-page-board-section-header-icon-image"
            src: orgLogoUrl1x
            srcSet: "#{orgLogoUrl1x} 1x, #{orgLogoUrl2x} 2x"
            alt: "#{title} logo"
        else
          t.span { class: "icon-lg icon-#{iconClass}" }

      t.h3 '.boards-page-board-section-header-name', ->
        t.text title

      if smallIconClass
        t.span '.boards-page-board-section-header-small-icon', ->
          t.icon smallIconClass, { title: t.l(smallIconTitleKey) }

      if linkElements
        t.div '.boards-page-board-section-header-options', ->
          for link in linkElements
            t.addElement link



// WEBPACK FOOTER //
// ./app/scripts/views/board-list/board-list-section-header-component.coffee